module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("absentmindedness")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Subject of many of the folk tales popular in New England. Man whittled off his finger by mistake. Another man gouges out his eyes in mistake for oysters.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Horace Greeley was well known for his absentmindedness. A hostess passed him some doughnuts. Continuing to talk he ate them all up. He next consumed the entire plate full of cheese cubes. When ultimately questioned about the situation he commented, “No disaster.”")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("absquatulate")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An artificially created term common to the West, meaning to leave or depart, usually hurriedly.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title4"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acadian customs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In that portion of Nova Scotia that continued to observe some of the feudal customs transferred to New France it was the practice of the farmers to give every twenty-sixth bushel of wheat to the Church. The story is told of this same region that one farmer with a large family announced his desire to dedicate his twenty-sixth child to the Church also.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("When the residents of Nova Scotia were removed by the British in 1755 some of the inhabitants joined their former countrymen in New Orleans where they introduced the activities associated with the Mardi Gras which they had originally brought from France. Since some of the Acadians only moved over into the St. John’s Valley of Maine there too they introduced some of the practices similar to the Louisianan Mardi Gras celebrations though of a more modest character. These carriers of the French traditions to Maine would put on costumes and visit from house to house for dancing, homemade wine and much laughter and merriment.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title5"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adam’s Tavern (later known as Wadsworth’s)")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This tavern is claimed as the oldest in Connecticut having remained in use for over two hundred years. Tradition asserts that the General Court, the colonial legislature, met there in 1687 with Andros, the King’s representative, who was threatening to take the colony’s charter away. While the precious document lay on the table it is claimed the candles were suddenly blown out. The charter disappeared, not to reappear again until James II was exiled and Andros was recalled.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title6"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adirondack customs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("See:")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("PRUCE")]), _vm._v(" B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EER")]), _vm._v(", B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("LUE")]), _vm._v(" L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("INE")]), _vm._v(" A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("CTIVITIES")]), _vm._v(", T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HEODORE")]), _vm._v(" R"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OOSEVELT")]), _vm._v(" G"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("UIDE")]), _vm._v(", H"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ONESTY")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("IN")]), _vm._v(" A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("DIRONDACKS")]), _vm._v(", L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EON")]), _vm._v(" L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("AKE")]), _vm._v(" H"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OUSE")]), _vm._v(", M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("APLE")]), _vm._v(" S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("UGAR")]), _vm._v(", M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("URRAY’S")]), _vm._v(" F"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OOLS")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title7"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adirondack guides")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("When the Adirondack country became a popular resort area the services of guides became an essential service to the thousands of summer visitors who have poured into the region for the past seventy years. These native residents were divided into significant grades of whom the “hotel guide” was the lowest category. He was paid by the hour by those who sought out his services. He might row the ladies as desired or lead a group on a hunting trip. “House Guides” were attached to a private estate and were paid by the month to help where needed. The aristocrats of the guides were those selected by a special clientele and known as “private guides.” They were reserved far in advance for week or month and paid very well. A certain village is still called “Easy Street” for this is where many of the guides spent the winter waiting for the next season of work. However in those early days their work would not be considered easy. A good guide would have to provide the boat and sometimes row twenty to thirty miles a day. Hauling over portages was also a very arduous task, so much so in fact that a special type boat was developed for that purpose, a canoe built like a row boat. The builders took off extra weight until they had one not much over sixteen feet in length weighing by itself only seventy-five pounds. Guides had to be expert also in finding the best camping spots, establishing effective smudge fires, cooking good meals. Guides were usually specialists being known for a particular region and never working outside of that district.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("“Old Mountain Phelps” was a colorful guide during much of the nineteenth century. He was called “a primitive man.” He hated soap and could do amazing things to the English language. He lived to be eighty-eight telling stories of his early exploits and selling guide books and pictures of himself.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title8"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ah Quong’s Inn")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("In the mining area about Bridgeport, California there is a legend about a fantan game run by a Chinese owner of a kind of inn where liquor and supplies were bought in the gold mining days. An Indian, Poker Tom, was known to have won one night over $300, and then never to have been seen again. However about a month later his head was found out in the woods by a squaw gathering pine nuts.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A search for the rest of his body was instituted at once in the hope that the cause of his death might be discovered but without success. Finally one of the Indian’s white friends decided to stay at the place under suspicion, Ah Quong’s Inn, and see what he could discover. Perhaps foreseeing the ultimate solution he was careful, so the story goes, to eat only rice and fish while he stayed there doing his best to inspect all the premises. Eventually he lifted out of the pickel barrel what was enough to assure him that his search was over!")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("There was indignation among the boarders of course, but the court found the evidence “of too fragmentary a nature” to be acceptable. However, before Ah Quong could leave the court four stalwart Indians entered and carried him off. Two hundred others were in the street. The telegraph wires were cut. The sheriff was out of town. The neighbors decided that the Indians had more imagination than they had given them credit for.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title9"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("albino animals")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("American Indians paid marked respect toward white animals. White dogs or buffalo calves were chosen as especially effective instruments of sacrifice. A White Coyote was thought by a California tribe to be the father of all other coyotes on earth. White deerskin was also particularly favored and used for ceremonial dances. White animals were also thought to have supernatural powers and therefore were often feared as well as desired. To see a white animal according to an Algonquin Indian belief would mean bad luck.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title10"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("algerines")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was a term created in Pennsylvania for log-pirates. These were men who stole logs floating down the Susquehanna. They sawed off the brand which had been placed on the end of a log during logging operations for identification purpose after all the logs had been collected at their destination. The Barbary pirates of Algiers led to the application of the name.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title11"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("All quiet on the Potomac")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This expression was said to have originated with General George McClellan during the Civil War while he was waiting to make his much delayed attack. The term has been carried over to apply to any circumstance where a person is waiting in peaceful circumstances for something to break forth. A recent usage has developed in reference to the “lady-in-waiting” whose pregnancy is advancing according to schedule.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title12"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“All the Law West of the Pecos”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was the position taken by Roy Bean a Kentucky-born Texas judge in the 1880’s who according to frontier legends, and the sign in his saloon was the center of law and order for many years. He held court in a town he managed to have named “Langtry” because he had fallen in love with the picture of the famous Lily. All his trials began with the request to “step up to the bar and have a snort of poison.” The actual performances were unique enough in themselves but the retelling for generations has embellished the material to a high polish. His trained bear drank beer at the bar and often helped in sobering drunks. As coroner he fined all dead men all the money on their person. Perhaps the most repeated tale concerns the problem of the killing of a Chinese laborer. He released the defendant because he could find nothing in the Texas lawbooks that condemned murdering a Chinese.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title13"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("alphabet recitation")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("There is an old theatrical saying, that words and meanings of lines are not as important as the ability of the actor. Any actor worthy of the name could earn applause by reciting the alphabet with varied intonation.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title14"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Al Smith")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Many of the stories told about Al Smith have already become part of the body of folklore. His brown derby and many of his pithy sayings illustrate the point. “Let’s look at the record,” “I think I’ll take a walk” have pungent meaning for politicians.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title15"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("alum")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Southern Negroes claim that it is valuable to stop bleeding, cure blindness and prevent conjure spells.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title16"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ambulance chaser")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("An expression created for a lawyer who is especially alert to obtain a case to defend a person who has had an accident and may want to bring suit as soon as possible, that is, he is so alert that he may arrive following the person who has been brought to the hospital in an ambulance.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title17"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Amish customs")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("See:")]), _vm._v(" A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("VOIDING")]), _vm._v(", A"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SCENSION")]), _vm._v(" D"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("AY")]), _vm._v(", T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HROW")]), _vm._v(" O"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("VER")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THE")]), _vm._v(" F"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ENCE")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title18"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("animals in folklore")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Animal anecdotes, cures, nurses and tales all have a part in Indian folklore and also in the various aspects of American folklore of the various localities of the United States. From Babe, Paul Bunyan’s ox, through all the mythological creatures popular in the tall tales of Arkansas, the Ozarks and the Northwest to the wily Brer Rabbit of the Uncle Remus Tales, animals form part of the pattern of American folk stories.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("See:")]), _vm._v(" B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("EAVER")]), _vm._v(", B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("IG")]), _vm._v(" O"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("WN")]), _vm._v(", B"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("RER")]), _vm._v(" R"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ABBIT")]), _vm._v(", C"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("AT")]), _vm._v(", C"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HAMELEON")]), _vm._v(", C"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OW")]), _vm._v(", C"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("RICKETS")]), _vm._v(", F"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ROG")]), _vm._v(", G"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OAT")]), _vm._v(", L"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OBO")]), _vm._v(", M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OLE")]), _vm._v(", M"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("USKRAT")]), _vm._v(", P"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("ORCUPINE")]), _vm._v(", S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HEEP")]), _vm._v(", S"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("NAKE")]), _vm._v(", T"), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OAD")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title19"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("anti-macassar")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was a little doily of lace or linen placed on the back of upholstered chairs or lounges to prevent soiling. The term originated because of the prevalent fashion for the gentlemen to dress their hair with an oil that was called macassar, so since these materials were against the oil, thus anti-macassar.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title20"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Arkansas Traveler")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("A well-known piece of American humor symbolizing the mythical state of “Arkansaw.” There are many versions of its origins but general acceptance centers on its being a medley of tales accumulating during the 1860’s and typifying the frontier distrust of strangers. A lost and tired Traveler seeking shelter for the night comes upon the Squatter. A lengthy dialogue ensues based on a number of deliberate misunderstandings. At last the Traveler wins acceptance by being able to play the balance of the tune the Squatter has been sawing at during most of the talk. Many of the jests had been popular long before they were incorporated in the dialogue and were retained over wide areas for popular entertainment purposes. A well-known one has to do with an account of a fair and square tapping of a barrel of whisky with a spigot at each end by a husband and wife who keep the drinking equal by each paying the other for the drinks taken. The Currier and Ives engraving of the incident was very popular.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title21"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Army folklore terms")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("See:")]), _vm._v(" Fat boy, guardhouse lawyer, gremlins, pentagon lore, hash marks, shave-tail, sick book rider, snow birds.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title22"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("asafetida")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This was an ill-smelling gum that was worn in a bag around the neck. The people in the Ozarks claim it prevents any digestive ills.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title23"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ascension Day")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Among the Amish of the Pennsylvania Dutch this is a day observed by a religious festival. Throughout this region there was a belief that no work should be done on this day, especially no sewing or bad luck would follow as a form of vengeance by the Lord.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title24"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("aspen leaf")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("The leaves of the aspen are said to tremble because the Lord’s cross was made of this wood, ignoring the fact that the long flexible leaf would be likely to be acted upon by any breath of air anyway.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title25"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("as straight as Pearl Street")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This comparison was a common expression in New Amsterdam with a distinctly satirical implication for this was one of the main streets of the town and swung around meanderingly on its way up town.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title26"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astor of Waldorf")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("John Jacob Astor came from the town of Waldorf in Germany to New York City where he began in a very modest way his fabulous business career. He was a peddler, first of cakes and later of fur skins and of cheap jewelry. Other accounts of the man to be the richest in America tell of his working for two dollars beating furs in a step in their preparation for sale. During this occupation he quizzed all the trappers with whom he came in contact so thoroughly and seemed to have acquired such a grasp of their work that the owner of the shop in which he was working sent him up to the Indian tribes in the Adirondacks and Canada to seek out skins for him. Astor learned to bargain most expertly and was always remarkably close-fisted, weighing every penny he dispersed. Starting to trade for himself his profits rose to unbelievable heights particularly because of monopolies he obtained.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("Later another fortune was accumulated by him by his shrewdness in recognizing real estate values. A story that has gained popular acceptance illustrates this point. He offered to sell a piece of property near Wall Street at what was for the time a rather low price of eight thousand dollars. He was told he was foolish to do that because within a few years that property would be worth twelve thousand dollars. However he explained his action by showing that with the money from his down town property he would buy eighty lots above Canal Street and by the time his Wall Street property was worth the twelve thousand his uptown property would have advanced to eighty thousand. Such farsightedness did soon bring him remarkable profits, but it is doubtful whether he ever explained his position in such a fashion for he was far from loquacious. Of his old age another story is told. He had learned from his business agent that a poor woman was unable to pay her rent for reasons so pitiful that the agent had not the heart to press her. However Astor insisted and soon the agent reported he had the money. Astor praised him for it, but actually his son had put up the money secretly.")])]), _vm._v(" "), _c('div', {
    staticClass: "section1"
  }, [_c('a', {
    attrs: {
      "id": "title27"
    }
  }), _c('div', {
    staticClass: "title-section1"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("“avoiding”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_vm._v("This curious custom was developed by the Amish, a religious sect among the Pennsylvania Dutch. The Amish refused all participation in election activities as a mark of unworldliness and they also avoided the use of buttons on coats and vests, still employing hooks and eyes in their place. If a member is censured by his church he is “avoided” also and must be ignored by all other Amish, his family included.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41d7f960","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780806536927_c01.vue
// module id = 69
// module chunks = 0